export const dispatchIcon = {
  default: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4 8.00001C14.4 11.5346 11.5346 14.4 8.00001 14.4C4.46538 14.4 1.60001 11.5346 1.60001 8.00001C1.60001 4.46538 4.46538 1.60001 8.00001 1.60001C11.5346 1.60001 14.4 4.46538 14.4 8.00001ZM8.80001 4.80001C8.80001 5.24183 8.44183 5.60001 8.00001 5.60001C7.55818 5.60001 7.20001 5.24183 7.20001 4.80001C7.20001 4.35818 7.55818 4.00001 8.00001 4.00001C8.44183 4.00001 8.80001 4.35818 8.80001 4.80001ZM7.20001 7.20001C6.75818 7.20001 6.40001 7.55818 6.40001 8.00001C6.40001 8.44183 6.75818 8.80001 7.20001 8.80001V11.2C7.20001 11.6418 7.55818 12 8.00001 12H8.80001C9.24183 12 9.60001 11.6418 9.60001 11.2C9.60001 10.7582 9.24183 10.4 8.80001 10.4V8.00001C8.80001 7.55818 8.44183 7.20001 8.00001 7.20001H7.20001Z"
      fill="#0B9C66"
    />
  ),
};

export const dispatchType = {
  default: {
    background: 'bg-utility-success-muted',
    icon: 'text-utility-success-base',
    buttonProps: {
      type: 'success',
      size: 'sm',
    },
    text: 'text-primitive-black',
  },
  danger: {
    background: 'bg-utility-danger-base',
    icon: 'text-utility-danger-base',
    buttonProps: {
      size: 'sm',
    },
    text: 'text-primitive-white',
  },
  warning: {
    background: 'bg-utility-warning-base',
    icon: 'text-utility-warning-base',
    buttonProps: {
      size: 'sm',
    },
    text: 'text-primitive-white',
  },
  info: {
    background: 'bg-utility-info-base',
    icon: 'text-utility-info-base',
    buttonProps: {
      size: 'sm',
    },
    text: 'text-primitive-white',
  },
  secondary: {
    background: 'bg-brand-secondary-base',
    icon: 'text-brand-secondary-base',
    buttonProps: {
      size: 'sm',
    },
    text: 'text-primitive-white',
  },
};
